/* Header behavior — mega menu touch/keyboard support, search reveal + predictive search,
   menu drawer. Hover-open is pure CSS; without JS every link still works (content in DOM). */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  var body = document.body;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mega menu: on touch, first tap opens the panel instead of navigating.
  var items = header.querySelectorAll('[data-mega]');
  function closeAll() {
    items.forEach(function (i) {
      i.classList.remove('open');
      i.querySelector('a').setAttribute('aria-expanded', 'false');
    });
  }
  items.forEach(function (item) {
    var link = item.querySelector('a');
    var touched = false;
    link.addEventListener('touchstart', function () { touched = true; }, { passive: true });
    link.addEventListener('click', function (ev) {
      if (touched && !item.classList.contains('open')) {
        ev.preventDefault();
        closeAll();
        item.classList.add('open');
        link.setAttribute('aria-expanded', 'true');
      }
    });
    item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); });
  });
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('[data-mega]')) closeAll();
  });

  // Search reveal
  var searchBtn = header.querySelector('[data-open-search]');
  var searchInput = header.querySelector('[data-search-input]');
  if (searchBtn) {
    searchBtn.addEventListener('click', function () {
      var open = header.classList.toggle('hdr--search-open');
      searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && searchInput) searchInput.focus();
    });
  }

  // Rotating placeholder suggestions (Ruggable pattern). Static under reduced motion.
  if (searchInput && !reduced) {
    var hints = ['Search rugs, kilims, runners…', 'Try “hand-knotted wool”', 'Try “jute runner”', 'Try “moroccan rug”', 'Try “cushion covers”'];
    var hi = 0;
    setInterval(function () {
      if (document.activeElement === searchInput || searchInput.value) return;
      hi = (hi + 1) % hints.length;
      searchInput.placeholder = hints[hi];
    }, 3200);
  }

  // Predictive search — Shopify's native suggest endpoint, no app. Renders product
  // suggestions under the search bar as you type; Enter/Search still runs the full search.
  var suggest = header.querySelector('[data-suggest]');
  if (searchInput && suggest) {
    var timer = null, lastQ = '';
    function hideSuggest() { suggest.hidden = true; suggest.innerHTML = ''; lastQ = ''; }
    function render(products, q) {
      if (!products.length) { hideSuggest(); return; }
      var rows = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '&width=96" alt="" loading="lazy">'
          : '<span class="hdr__suggest-blank"></span>';
        return '<a href="' + p.url + '">' + img + '<span><em>' + p.title + '</em><small>' + (p.price ? '$' + p.price : '') + '</small></span></a>';
      }).join('');
      suggest.innerHTML = rows +
        '<a class="hdr__suggest-all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + q.replace(/</g, '&lt;') + '”</a>';
      suggest.hidden = false;
    }
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hideSuggest(); return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (searchInput.value.trim() !== q) return; // stale response
            lastQ = q;
            render((d.resources && d.resources.results && d.resources.results.products) || [], q);
          })
          .catch(hideSuggest);
      }, 250);
    });
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest('.hdr__search')) hideSuggest();
    });
  }

  // Mobile menu drawer
  var burger = header.querySelector('[data-open-menu]');
  function closeMenu() {
    body.classList.remove('menu-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }
  if (burger) {
    burger.addEventListener('click', function () {
      body.classList.add('menu-open');
      burger.setAttribute('aria-expanded', 'true');
    });
  }
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-close-menu]')) closeMenu();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAll();
    closeMenu();
    if (suggest) { suggest.hidden = true; suggest.innerHTML = ''; }
    if (header.classList.contains('hdr--search-open')) {
      header.classList.remove('hdr--search-open');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    }
  });
})();
